<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <text-input
      v-model="form.name"
      :date-not-in-future="true" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('justiceworkers.name')"
      :required="true"
    />
    <text-input
      v-model="form.function"
      :date-not-in-future="true" :error="form.errors.function" class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('justiceworkers.function')"
      :required="true"
    />
    <text-input
      v-model="form.date"
      :date-not-in-future="true" type="date" :error="form.errors.date" class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('justiceworkers.date')"
      :required="true"
    />

    <textarea-input
      v-model="form.note" :error="form.errors.note" class="pb-8 pr-6 w-full lg:w-4/4"
      :label="$t('justiceworkers.note')"
      :required="true"
    />
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    TextInput,
    TextareaInput,
  },
  props: ['formData'],
  computed: {
    form() {
      return this.formData
    },
  },
}
</script>
